<template>
    <div class="device-type-add">
        <el-page-header @back="goBack" content="邮箱设置"></el-page-header>
        <el-form label-width="150px" class="form" :model="ruleForm" :rules="rules" ref="ruleForm"
                 style="width: 50%;margin: 20px auto 0 auto;" autocomplete="off" label-position="left">
            <el-form-item label="发件方名称" prop="from_name">
                <el-input type="text" v-model="ruleForm.from_name" id="from_name" placeholder="请输入发件方名称"
                          autocomplete="off" style="width: 50%;float: left;"></el-input>
            </el-form-item>
            <el-form-item label="发件邮箱地址" prop="from_mail">
                <el-input type="text" v-model="ruleForm.from_mail" id="from_mail" placeholder="请输入发件邮箱地址" autocomplete="off"
                          style="width: 50%;float: left;"></el-input>
            </el-form-item>
            <el-form-item label="SMTP服务器" prop="host">
                <el-input type="text" v-model="ruleForm.host" id="host" placeholder="请输入SMTP服务器"
                          style="width: 50%;float: left;"></el-input>
            </el-form-item>
            <el-form-item label="SMTP服务器端口" prop="port">
                <el-input type="text" v-model="ruleForm.port" id="port" placeholder="请输入SMTP服务器端口"
                          autocomplete="off" style="width: 50%;float: left;"></el-input>
            </el-form-item>
            <el-form-item label="连接方式" prop="smtp_secure">
                <el-select v-model="ruleForm.smtp_secure" placeholder="请选择连接方式" style="width: 50%;float: left;">
                    <el-option
                        v-for="item in smtp_secure_arr"
                        :key="item.id"
                        :label="item.name"
                        :value="item.value"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="发件邮箱帐号" prop="mail_username">
                <el-input type="text" v-model="ruleForm.mail_username" id="mail_username" placeholder="请输入发件邮箱帐号"
                          style="width: 50%;float: left;"></el-input>
            </el-form-item>
            <el-form-item label="发件邮箱密码" prop="mail_password">
                <el-input type="password" v-model="ruleForm.mail_password" :show-password="true"  placeholder="请输入发件邮箱密码"
                          style="width: 50%;float: left;"></el-input>
            </el-form-item>

            <!-- form表单提交 -->
            <el-form-item class="submit_btn">
                <el-button type="default" @click="sendTestMail">测试邮件</el-button>
                <el-button type="success" @click="submitForm('ruleForm')">保存</el-button>
            </el-form-item>
        </el-form>

        <el-dialog title="发送测试邮件" :visible.sync="mailerDialog">
            <el-form label-position="right" :model="mailForm" :rules="mailRules" ref="mailForm"
                     label-width="150px"
                     class="form" style="width: 80%;margin: 20px auto 0 auto;" autocomplete="off">
                <el-form-item label="邮件标题" prop="title">
                    <el-input type="text" v-model="mailForm.title" placeholder="请输入邮件标题" autocomplete="off"
                              style="width: 100%;"></el-input>
                </el-form-item>
                <el-form-item label="收件邮箱" prop="to_mail">
                    <el-input type="text" v-model="mailForm.to_mail" placeholder="请输入收件箱" autocomplete="off"
                              style="width: 100%;"></el-input>
                </el-form-item>
                <el-form-item label="邮件内容" prop="content">
                    <el-input type="textarea" v-model="mailForm.content" placeholder="请输入邮件内容" autocomplete="off"
                              style="width: 100%;"></el-input>
                </el-form-item>
                <el-form-item label="邮件附件" :label-width="formLabelWidth">
                    <el-upload ref="upload" class="upload-demo" accept=".jpg,.png,.jpeg,.JPEG,.JPG,.PNG,.pdf,.PDF"
                               :action="upload_path" :file-list="fileList"
                               :on-success="handleSuccess" :before-upload="beforeAvatarUpload" list-type="picture"
                               :multiple="true" :limit="9">
                        <div slot="file" slot-scope="{file}">
                            <pdf class="el-upload-list__item-thumbnail"  v-if="file.name.endsWith('.pdf')" :src="file.url"></pdf>
                            <img v-else class="el-upload-list__item-thumbnail" :src="file.url" alt=""/>
                            <a class="el-upload-list__item-name"><i class="el-icon-document"></i>{{ file.name }}</a>
                            <label class="el-upload-list__item-status-label">
                                <i class="el-icon-upload-success el-icon-check"></i>
                            </label>
                            <i class="el-icon-close" @click="handleRemove(file)"></i>
                            <i class="el-icon-close-tip">按 delete 键可删除</i>
                        </div>

                        <el-button class="upload_btn" size="small" type="primary" v-if="addFileList.length < 9">点击上传
                        </el-button>
                        <div slot="tip" class="el-upload__tip" v-if="addFileList.length < 9">注：请上传小于5M的图片，格式支持PNG,JPG,PDF
                        </div>
                    </el-upload>

                    <div class="upload-demo">
                        <el-button class="file_view" size="small" type="primary"
                                   @click="oneReservationDetail({contract_file: JSON.stringify(addFileList)})">预览附件
                        </el-button>
                    </div>

                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="mailerDialog = false">取 消</el-button>
                <el-button type="primary" @click="sendMail">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="附件预览" :visible.sync="dialogContractFormVisible">
            <el-carousel indicator-position="outside" height="500px" :autoplay="false">
                <el-carousel-item v-for="url in allContractUrls" :key="url">
                    <div class="image_box">
                        <pdf :src="url" v-if="getFileType(url) == 'pdf'"></pdf>
                        <el-image :src="url" v-else></el-image>
                    </div>
                </el-carousel-item>
            </el-carousel>
        </el-dialog>
    </div>
</template>
<script>
    import env from "@/api/env";
    import {getUserInfos} from '@/utils/userInfos';
    import {check} from "@/utils/checkData";
    import pdf from 'vue-pdf'
    import {fileType} from "@/api/order";

    export default {
        components: {
            pdf
        },
        mounted() {
            this.getMailerSetDetail();
            localStorage.setItem('prev_page', 'mail_list')
        },
        data() {
            return {
                dialogContractFormVisible: false,
                mailerDialog: false,
                formLabelWidth: '120px',
                upload_path: env.IMG_COMMON_REQUEST_URL_PREFIX + '?type=99',
                fileList: [],
                addFileList: [],
                allContractUrls: [],
                ruleForm: {
                    id: '',
                    from_name: '',
                    from_mail: '',
                    host:'',
                    port:'',
                    smtp_secure:'',
                    mail_username: '',
                    mail_password: '',
                },
                smtp_secure_arr: [
                    {
                        id: 1,
                        name: '默认',
                        value: '',
                    },
                    {
                        id: 2,
                        name: 'ssl',
                        value: 'ssl',
                    },
                    {
                        id: 3,
                        name: 'tls',
                        value: 'tls',
                    },
                ],
                mailForm: {
                    to_mail: '',
                    title: '',
                    content: '',
                    file: '',

                },
                rules: {
                    from_name: [
                        {required: true, message: "请输入发件方名称", trigger: "blur"},
                    ],
                    from_mail: [
                        {required: true, message: "请输入发件邮箱地址", trigger: "blur"},
                        {}
                    ],
                    host: [
                        {required: true, message: "请输入SMTP服务器", trigger: "blur"},
                    ],
                    port: [
                        {required: true, message: "请输入SMTP服务器端口", trigger: "blur"},
                    ],
                    // smtp_secure: [
                    //     {required: true, message: "请选择连接方式", trigger: "blur"},
                    // ],
                    mail_username: [
                        {required: true, message: "请输入发件邮箱帐号", trigger: "blur"},
                    ],
                    mail_password: [
                        {required: true, message: "请输入发件邮箱密码", trigger: "blur"},
                    ],
                },
                mailRules: {
                    to_mail: [
                        {required: true, message: "请输入收件箱地址", trigger: "blur"},
                    ],
                    title: [
                        {required: true, message: "请输入邮件标题", trigger: "blur"},
                    ],
                    content: [
                        {required: true, message: "请输入邮件内容", trigger: "blur"},
                    ],
                }
            };
        },
        methods: {
            // 发送邮件
            sendMail(){
                this.$refs["ruleForm"].validate(valid => {
                    if (valid) {
                        // 新增预约
                        let params = {
                            servername: 'Ruyi_AdminSystemServices',
                            method: 'sendTestMail',
                            params: {
                                to_mail: this.mailForm.to_mail,
                                title: this.mailForm.title,
                                content: this.mailForm.content,
                                file: this.addFileList
                            }
                        };
                        this.$api.service(params).then(res => {
                            if (!check(res)) {
                                return;
                            }
                            if (res.data.code != '0') {
                                this.$message({
                                    type: "error",
                                    message: res.data.msg,
                                    duration: 1500,
                                });
                                return;
                            }
                            this.$message({
                                type: "success",
                                message: '邮件发送成功',
                                duration: 1500
                            });
                            this.mailerDialog = false;
                        });
                    }
                })
            },
            // 除去图片
            handleRemove(file, fileList) {
                var addFileList = [];
                var imageUrl = this.imgUrl;
                for (var i = 0; i < fileList.length; i++) {
                    if (fileList[i].status == 'success') {
                        if (fileList[i].response && fileList[i].response.data) {
                            addFileList.push(fileList[i].response.data);
                        } else {
                            let name = fileList[i].url.substring(imageUrl.length, fileList[i].url.length);
                            addFileList.push(name);
                        }
                    }
                }
                this.addFileList = addFileList;
            },
            // 上传图片成功
            handleSuccess(response, file, fileList) {
                var addFileList = [];
                var imageUrl = this.imgUrl;
                for (var i = 0; i < fileList.length; i++) {
                    if (fileList[i].status == 'success') {
                        if (fileList[i].response && fileList[i].response.data) {
                            addFileList.push(fileList[i].response.data);
                        } else {
                            let name = fileList[i].url.substring(imageUrl.length, fileList[i].url.length);
                            let obj = {
                                file: name,
                                x: fileList[i].x,
                                y: fileList[i].y,
                            };
                            addFileList.push(obj);
                        }
                    }
                }
                this.addFileList = addFileList;
                this.mailForm.file = "file";
            },
            //上传图片之前，检测文件格式
            beforeAvatarUpload(file) {
                if (file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'application/pdf') {
                    var isJPG = true;
                } else {
                    var isJPG = false;
                }
                const isLt5M = file.size / 1024 / 1024 < 5;
                if (!isJPG) {
                    this.$message.error('图片只能是jpg/png/pdf格式!');
                }
                if (!isLt5M) {
                    isJPG = false;
                    this.$message.error('图片大小不能超过5MB!');

                }
                return isJPG;
            },
            // 详情
            getMailerSetDetail() {
                let params = {
                    'servername': 'Ruyi_AdminSystemServices',
                    'method': 'getMailerParams'
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    if (res.data.data) {
                        if (res.data.data.id) {
                            this.ruleForm.id = res.data.data.id;
                        }
                        this.ruleForm.from_name = res.data.data.from_name || ''
                        this.ruleForm.from_mail = res.data.data.from_mail || ''
                        this.ruleForm.host = res.data.data.host || ''
                        this.ruleForm.port = res.data.data.port || ''
                        this.ruleForm.smtp_secure = res.data.data.smtp_secure || ''
                        this.ruleForm.mail_username = res.data.data.username || ''
                        this.ruleForm.mail_password = res.data.data.password || ''
                    }
                });
            },
            // 附件详情
            oneReservationDetail(data) {
                this.allContractUrls = [];
                var allContractUrls = [];
                if (data.contract_file) {
                    var contract_file = JSON.parse(data.contract_file);
                    if (contract_file.length > 0) {
                        for (var i = 0; i < contract_file.length; i++) {
                            var url = this.imgUrl + contract_file[i].file;
                            allContractUrls.push(url);
                        }
                    }
                }
                this.allContractUrls = allContractUrls;
                this.dialogContractFormVisible = true;
            },

            // 返回上一页
            goBack() {
                window.history.go(-1);
            },
            sendTestMail() {

                this.mailForm.to_mail = '';
                this.mailForm.title = '';
                this.mailForm.content = '';
                this.addFileList = [];
                this.fileList = [];
                this.$nextTick(() => {
                    this.mailerDialog = true;
                });
            },
            // 提交表单
            submitForm(formName) {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复提交',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                let _that = this
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        let params = {
                            'servername': 'Ruyi_AdminSystemServices',
                            'method': 'mailerSet',
                            'params': {
                                id: this.ruleForm.id,
                                from_name: this.ruleForm.from_name,
                                from_mail: this.ruleForm.from_mail,
                                host: this.ruleForm.host,
                                port:this.ruleForm.port,
                                smtp_secure:this.ruleForm.smtp_secure,
                                username:this.ruleForm.mail_username,
                                password: this.ruleForm.mail_password
                            }
                        };
                        this.$api.service(params).then(res => {
                            if (res.data.code != '0') {
                                this.$message({
                                    type: "error",
                                    message: '设置错误'
                                });
                            } else {
                                this.$message({
                                    type: "success",
                                    message: '设置成功',
                                });
                                this.getMailerSetDetail();
                            }
                            this.is_submit = false;
                        }).finally(() => {
                            this.is_submit = false;
                        });
                    } else {
                        this.$message({
                            type: "error",
                            message: '请输入必填项'
                        });
                        this.is_submit = false;
                        return false;
                    }
                });
                this.is_submit = false;
            },
            getFileType(url) {
                return fileType(url)
            },
        }

    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 316px;
        height: 200px;
        line-height: 200px;
        text-align: center;
    }

    .avatar {
        width: 316px;
        height: 200px;
        display: block;
    }

    .editor {
        line-height: normal !important;
        height: 800px;
    }
    .submit_btn {
        .el-form-item__content{
            margin-left: 0 !important;
        }
    }

    .image_box {
        height: 500px;
        overflow: hidden;
        overflow-y: auto;

        image {
            width: 100%;
        }
    }

    .upload_btn {
        position: absolute;
        top: 0;
        left: 30px;
    }

    .file_view {
        position: absolute;
        top: 0;
        left: 130px;
    }

</style>
